export  default  {

    // getBoxHeight(className) {
    //     let container = document.getElementsByClassName("vm--modal");
    //     let style = window.getComputedStyle(container[0]);
    //
    //     let ControlLibraryList = (document.getElementsByClassName(className)[0]);
    //
    //     return parseInt(style.height.replace("px", "")) - ControlLibraryList.offsetTop - 30
    // }
    // ,
    // autoHeight(className) {
    //
    //
    //     if (window.screen.width >= 650)
    //             return ;
    //
    //     let modelBoxHeight  = this.getBoxHeight(className)
    //     let sBoxHeight = parseInt(window.getComputedStyle(document.getElementsByClassName(className +"-ModalBox")[0]).height.replace("px", ""))
    //
    //     if (modelBoxHeight > sBoxHeight)
    //     {
    //         document.getElementsByClassName("vm--modal")[0].style.height = '422px'
    //     }
    //     else {
    //         document.getElementsByClassName("vm--modal")[0].style.height = window.screen.height * 0.8 + 'px'
    //     }
    //
    //     let ControlLibraryList = (document.getElementsByClassName(className)[0]);
    //
    //     let box =  window.screen.height * 0.8 - ControlLibraryList.offsetTop - 30
    //
    //
    //      document.getElementsByClassName(className)[0].style.height = box + 'px'
    // }


    handle() {

        let sBoxHeight = parseInt(window.getComputedStyle(document.getElementsByClassName("modal-box")[0]).height.replace("px", ""))
        document.getElementsByClassName("vm--modal")[0].style.height = (sBoxHeight + 100) +  'px'
        document.getElementsByClassName("vm--modal")[0].style.top = ((window.screen.height - (sBoxHeight + 100) )/2) +  'px'

    }
}